function isEscPressed(event) {
  return event.key && (event.key === 'Esc' || event.key === 'Escape');
}

export default isEscPressed;
